import { FORMS_KEYS } from "helper/constant";
import React from "react";
import moment from "moment";

const KEYS = FORMS_KEYS.abn;

const FormElement = ({ question, answer }) => (
  <div className="p-2">
    <div className="fs-16 demi-bold-text">{question}</div>
    <div>
      <i className="fas fa-arrow-right pr-1" />
      {answer != null && answer !== "" ? answer : "N/A"}
    </div>
  </div>
);

const ABN_OPTION_TEXT = {
  "1":
    "OPTION 1 — I want the item(s) or service(s) listed above. You may ask to be billed and submit a claim to Medicare.",
  "2":
    "OPTION 2 — I want the item(s) or service(s) listed above, but do not bill Medicare (pay out of pocket).",
  "3":
    "OPTION 3 — I do not want the item(s) or service(s) listed above (decline the service)."
};

const parseLineItems = data => {
  const raw = data?.service_line_items;
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const AbnForm = ({ data }) => {
  if (!data) {
    return <div className="fs-16">No ABN form data found.</div>;
  }

  const lineItems = parseLineItems(data);

  return (
    <div>
      <div className="fs-18 bold-text pb-2">
        Advance Beneficiary Notice of Non-coverage (ABN)
      </div>
      <div className="fs-14 text-muted pb-2">Form CMS-R-131</div>

      <FormElement question={KEYS.notifier} answer={data?.notifier} />
      <FormElement question={KEYS.patient_name} answer={data?.patient_name} />
      <FormElement
        question={KEYS.identification_number}
        answer={data?.identification_number}
      />

      {lineItems.length > 0 ? (
        <div className="p-2">
          <div className="fs-16 demi-bold-text">{KEYS.service_line_items}</div>
          <table className="table table-bordered mt-2">
            <thead>
              <tr>
                <th>{KEYS.item_service}</th>
                <th>{KEYS.reason_medicare_may_not_pay}</th>
                <th>{KEYS.estimated_cost}</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.map((row, index) => (
                <tr key={index}>
                  <td>{row?.item_service || "N/A"}</td>
                  <td>{row?.reason_medicare_may_not_pay || "N/A"}</td>
                  <td>{row?.estimated_cost || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <FormElement question={KEYS.service_line_items} answer={null} />
      )}

      <FormElement
        question={KEYS.selected_option}
        answer={ABN_OPTION_TEXT[data?.selected_option] || data?.selected_option}
      />
      <FormElement
        question={KEYS.additional_information}
        answer={data?.additional_information}
      />
      <FormElement question={KEYS.signature} answer={data?.signature} />
      <FormElement
        question={KEYS.signed_date}
        answer={
          data?.signed_date
            ? moment(data.signed_date).format("MM/DD/YYYY")
            : null
        }
      />
    </div>
  );
};

export default AbnForm;
